import { BetData } from "@/shared/model/bet";
import { Outcome, Tags } from "@/shared/model/ticket";
import { OutcomeResults } from "@/ticket/model/ticket-outcome-results";

export default function useTicketUtils() {
    const getTicketType = (ticket: BetData) => {
        if (!ticket.isSettled) return "in-progress";
        if (ticket.refunds != "0.00") {
            return "return";
        } else if (ticket.status == "CASHED_OUT") {
            return "cashout";
        } else if (ticket.winnings != "0.00") {
            return "win";
        } else {
            return "lose";
        }
    };

    const getOutcomeIcon = (outcome: Outcome) => {
        if (!outcome.outcomeDetails) return "time";
        switch (outcome.outcomeDetails.result) {
            case OutcomeResults.WIN:
                return "win";
            case OutcomeResults.LOSE:
                return "lose";
            case OutcomeResults.VOID:
                return "return";
            default:
                return "time";
        }
    };

    const getLiveScore = (liveTags: Tags[]) => {
        const liveScore = liveTags?.find((tag) => tag.name === "SCORE");
        return liveScore?.value;
    };

    return {
        getTicketType,
        getOutcomeIcon,
        getLiveScore,
    };
}
